import style from "./index.module.scss";
import WrapperContent from "../../components/shared/WrapperContent";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import HeaderContentNew from "../../components/shared/HeaderContentNew/HeaderContentNew";
import AnalyticsTransport from "../../components/analytics/transport/AnalyticsTransport";
import AnalyticsAviation from "../../components/analytics/aviation/AnalyticsAviation";
import { useSelector } from "react-redux";
import AccessDeniedModal from "../../components/shared/SubscriptionModal/AccessDeniedModal";
import AnalyticsTransportExpeditor from "../../components/analytics/transport/AnalyticsTransportExpeditor";
import AnalyticsAviationExpeditor from "../../components/analytics/aviation/AnalyticsAviationExpeditor";

const AnalyticsPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('aviation');
  const [isDisplayModal, changeDisplayModal] = useState(false);
  const { user } = useSelector((state) => state);

  const isUserLoaded = user && user.permissions !== undefined;
  const hasAnalyticsPermission = isUserLoaded && user?.permissions?.includes("analityca_view");

  useEffect(() => {
    if (isUserLoaded && !hasAnalyticsPermission) {
      changeDisplayModal(true);
      const handleContextMenu = (e) => e.preventDefault();

      const handleKeyDown = (e) => {
        if (
          e.key === 'F12' ||
          (e.ctrlKey && e.shiftKey && e.key === 'I') ||
          (e.ctrlKey && e.shiftKey && e.key === 'C') ||
          (e.ctrlKey && e.key === 'U') ||
          (e.ctrlKey && e.shiftKey && e.key === 'J')
        ) {
          e.preventDefault();
          return false;
        }
      };

      const detectDevTools = () => {
        const threshold = 160;
        const widthThreshold = window.outerWidth - window.innerWidth > threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > threshold;

        if (widthThreshold || heightThreshold) {
          window.location.reload();
        }
      };

      const devToolsInterval = setInterval(detectDevTools, 1000);

      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
      document.body.style.mozUserSelect = 'none';
      document.body.style.msUserSelect = 'none';

      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
        document.removeEventListener('keydown', handleKeyDown);
        clearInterval(devToolsInterval);
        document.body.style.userSelect = '';
        document.body.style.webkitUserSelect = '';
        document.body.style.mozUserSelect = '';
        document.body.style.msUserSelect = '';
      };
    }
  }, [isUserLoaded, hasAnalyticsPermission]);

  if (!isUserLoaded) {
    return (
      <>
        <HeaderContentNew
          title={t('analytics.pageTitle')}
          displayTitle={true}
          displayCreateBtn={false}
          displayReloadBtn={false}
        />
        <div className={style.mainContent}>
          <div className={style.tabsContainer}>
            <button className={`${style.tabButton} ${style.active}`}>
              {t('analytics.tabAir')}
            </button>
            <button className={style.tabButton}>
              {t('analytics.tabTransport')}
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <HeaderContentNew
        title={t('analytics.pageTitle')}
        displayTitle={true}
        displayCreateBtn={false}
        displayReloadBtn={false}
      />

      <div className={`${style.mainContent} ${!hasAnalyticsPermission ? style.blurred : ''}`}>
        <div className={style.tabsContainer}>
          <button
            className={`${style.tabButton} ${activeTab === 'aviation' ? style.active : ''}`}
            onClick={() => setActiveTab('aviation')}
          >
            {t('analytics.tabAir')}
          </button>
          <button
            className={`${style.tabButton} ${activeTab === 'transport' ? style.active : ''}`}
            onClick={() => setActiveTab('transport')}
          >
            {t('analytics.tabTransport')}
          </button>
        </div>

        <WrapperContent>
          {activeTab === 'aviation' && (
            user?.type === "Expeditor" 
              ? <AnalyticsAviationExpeditor user={user} /> 
              : <AnalyticsAviation user={user} />
          )}
          {activeTab === 'transport' && (
            user?.type === "Expeditor" 
              ? <AnalyticsTransportExpeditor user={user} /> 
              : <AnalyticsTransport user={user} />
          )}
        </WrapperContent>
      </div>

      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}
    </>
  );
};

export default AnalyticsPage;